import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import Money from "../../utils/Money";

export default class ActiveReservationsTableView extends Component {

    static propTypes = {
        reservations: PropTypes.arrayOf(PropTypes.shape({
            reservationRequestId: PropTypes.number.isRequired,
            advertisementId: PropTypes.number.isRequired,
            advertisementTitle: PropTypes.string.isRequired,
            spaceId: PropTypes.number.isRequired,
            spaceTitle: PropTypes.string.isRequired,
            statusId: PropTypes.number.isRequired,
            statusName: PropTypes.string.isRequired,
            startDate: PropTypes.string.isRequired,
            endDate: PropTypes.string.isRequired,
            created: PropTypes.number.isRequired,
            updated: PropTypes.number.isRequired,
            deleted: PropTypes.bool.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            hasOverLappingRequests: PropTypes.bool.isRequired,
        }))
    };

    render() {
        if (this.props.reservations.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no Active Advertisement Reservations.
                    <br/>
                    Once a reservation has been accepted by the Space Owner
                    <br/>
                    and you've paid for it
                    <br/>
                    you can begin contacting the Space owner here.
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="d-flex align-content-stretch flex-wrap">
                    {
                        this.props.reservations.map((reservation) => {
                            const isActive = Time.isNowWithinRange(reservation.startDate, reservation.endDate);
                            const cardClass = isActive ? "border-success" : "border-warning";
                            const cardTitleClass = isActive ? "text-success": "text-warning";

                            return (
                                <div className="col-xs-12 col-md-6 col-lg-4 pt-2" key={"Reservation-"+reservation.reservationRequestId}>
                                    <div className={"card rounded h-100 "+cardClass}>
                                        <div className={"card-header text-center " + cardTitleClass}>
                                            {isActive ? "Active Reservation" : "Upcoming Reservation"}
                                        </div>
                                        <div className="card-body border-top-box pb-1" id={reservation.reservationRequestId}>
                                            <div className="row">
                                                <div className="col-6 border-right">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Ad
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleAdvertisementClicked(reservation.advertisementId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.advertisementTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Space
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleSpaceClicked(reservation.spaceId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.spaceTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Date Range
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._convertTimestampToStartAndEndString(reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Total Value
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._calculatePrice(reservation.pricePerDay, reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer p-0">
                                            <div className="row m-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary w-100"
                                                    onClick={(e) => this.handleContactInfoClicked(reservation.spaceId)}
                                                >
                                                    <i className="fas fa-comment-alt mr-1" />
                                                    Contact Space Owner
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </React.Fragment>
        );
    }

    handleSpaceClicked = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.ACCEPTED_RESERVATIONS_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleAdvertisementClicked = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.ACCEPTED_RESERVATIONS_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    handleContactInfoClicked = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.SPACE_OWNER_CONTACT_INFO_BUTTON_CLICKED, {spaceId: spaceId});
    };

    _convertTimestampToStartAndEndString(start, end) {
        return Time.parseDate(start).toLocaleDateString() + " to " + Time.parseDate(end).toLocaleDateString();
    }

    _calculatePrice(pricePerDay, startDate, endDate) {
        const numberOfDaysInReservation = Time.calculateDifferenceInDaysBetweenInclusive(Time.parseDate(startDate), Time.parseDate(endDate));
        return Money.formatMoney(pricePerDay * numberOfDaysInReservation);
    }

}

